import React from "react";
import {
  Box,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { getSuppressionAccountLabels } from "../utils/scheduleNameFormatter";
import { ACCOUNT_DETAIL_FONT_FAMILY } from "../../../../components/AccountDetailPolicy/accountDetailTypography";

const MENU_ITEM_SX = {
  fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
  fontSize: "0.875rem",
  fontWeight: 500,
  color: "#111827",
  mx: 0.5,
  my: 0.25,
  borderRadius: "6px",
  "&:hover": {
    backgroundColor: "#fff4eb",
  },
  "&.Mui-selected": {
    fontWeight: 600,
    color: "#fff",
    backgroundColor: "#F98125",
    "&:hover": {
      backgroundColor: "#e8741c",
      color: "#fff",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#e8741c",
      color: "#fff",
    },
  },
};

const SuppressionFilters = ({
  availableAccountNumbers,
  selectedAccountNumber,
  onAccountChange,
  isAzureView = false,
}) => {
  const accountLabels = getSuppressionAccountLabels(isAzureView);
  return (
    <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
      <FormControl size="small">
        <Select
          value={selectedAccountNumber || ""}
          onChange={(e) => onAccountChange(e.target.value)}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return (
                <Box
                  sx={{
                    fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
                    color: "#94a3b8",
                    fontWeight: 400,
                    fontSize: "0.875rem",
                  }}
                >
                  {accountLabels.noun}
                </Box>
              );
            }
            return (
              <Box
                sx={{
                  fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  color: "#111827",
                }}
              >
                {selected}
              </Box>
            );
          }}
          sx={{
            minWidth: 180,
            height: 40,
            fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
            fontSize: "0.875rem",
            backgroundColor: "#fff",
            borderRadius: "8px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#e2e8f0",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#cbd5e1",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#111827",
              borderWidth: "1px",
            },
            "& .MuiSelect-select": {
              py: 0,
              display: "flex",
              alignItems: "center",
            },
            "& .MuiSelect-icon": {
              color: "#94a3b8",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)",
                border: "1px solid #e2e8f0",
                mt: 0.5,
                maxHeight: 300,
                overflow: "hidden",
                "& .MuiList-root": {
                  py: 0.5,
                },
              },
            },
          }}
        >
          <MenuItem value="" sx={MENU_ITEM_SX}>
            {accountLabels.all}
          </MenuItem>
          {availableAccountNumbers.map((accountNumber) => (
            <MenuItem
              key={accountNumber}
              value={accountNumber}
              sx={MENU_ITEM_SX}
            >
              {accountNumber}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SuppressionFilters;
